<template>
  <div>
    <section class="section-padding bg-white">
      <div class="container-width max-w-4xl">
        <h1 class="text-dark-900 mb-8">Impressum</h1>

        <div class="space-y-8 text-dark-700">
          <div>
            <h2 class="text-2xl font-bold text-dark-900 mb-4">Angaben gemäß § 5 TMG</h2>
            <p class="leading-relaxed">
              Enrico Reinsdorf<br>
              Züricher Str. 52<br>
              90431 Nürnberg
            </p>
          </div>

          <div>
            <h2 class="text-2xl font-bold text-dark-900 mb-4">Kontakt</h2>
            <p class="leading-relaxed">
              Telefon: +49 177 2022447<br>
              E-Mail: <a href="mailto:enrico.reinsdorf@re-design.de" class="text-primary-500 hover:text-primary-600">enrico.reinsdorf@re-design.de</a>
            </p>
          </div>

          <div>
            <h2 class="text-2xl font-bold text-dark-900 mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p class="leading-relaxed">
              Enrico Reinsdorf<br>
              Züricher Str. 52<br>
              90431 Nürnberg
            </p>
          </div>

          <div>
            <h2 class="text-2xl font-bold text-dark-900 mb-4">EU-Streitschlichtung</h2>
            <p class="leading-relaxed">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" class="text-primary-500 hover:text-primary-600 underline">
                https://ec.europa.eu/consumers/odr/
              </a><br>
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </div>

          <div>
            <h2 class="text-2xl font-bold text-dark-900 mb-4">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
            <p class="leading-relaxed">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>

          <div class="border-t border-gray-200 pt-8">
            <h2 class="text-2xl font-bold text-dark-900 mb-4">Haftung für Inhalte</h2>
            <p class="leading-relaxed mb-4">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen
              zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p class="leading-relaxed">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
              Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
              Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
              Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </div>

          <div>
            <h2 class="text-2xl font-bold text-dark-900 mb-4">Haftung für Links</h2>
            <p class="leading-relaxed mb-4">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
              verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
            <p class="leading-relaxed">
              Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
              Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche
              Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
              zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
          </div>

          <div>
            <h2 class="text-2xl font-bold text-dark-900 mb-4">Urheberrecht</h2>
            <p class="leading-relaxed mb-4">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
              Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
              Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
            <p class="leading-relaxed">
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
              Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem
              auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
              Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
useHead({
  title: 'Impressum',
  meta: [
    { name: 'robots', content: 'noindex, nofollow' }
  ]
})
</script>
